import { FunctionComponent, ReactNode } from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/es/button/button';
import { PlatformBtnText, TradingPlatformData } from '@monorepo/client-common';
import { TradingPlatforms } from '@monorepo/client-types';
import { SystemIcon } from '@monorepo/nova-icons';

export const PlatformIcon: { [key: string]: ReactNode } = {
  [TradingPlatforms.Web]: <SystemIcon iconName="Globe" />,
  [TradingPlatforms.Mac]: <SystemIcon iconName="AppleLogo" />,
  [TradingPlatforms.Windows]: <SystemIcon iconName="WindowsLogo" />,
  [TradingPlatforms.Linux]: <SystemIcon iconName="LinuxLogo" />,
  [TradingPlatforms.iOS]: <SystemIcon iconName="AppleLogo" />,
  [TradingPlatforms.Android]: <SystemIcon iconName="AndroidLogo" />,
};

export const TradingSystemBtn: FunctionComponent<
  { platformData: TradingPlatformData } & ButtonProps
> = ({ platformData, ...rest }) => {
  const handleTraderClick = (link: string) => {
    window.open(link, '_blank');
  };

  return (
    <Button
      icon={PlatformIcon[platformData.platform]}
      type="primary"
      onClick={() => handleTraderClick(platformData.link)}
      {...rest}
    >
      {PlatformBtnText[platformData.platform]}
    </Button>
  );
};
